import { listado } from "./listado";
import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    nombre: "",
  };
}

export function listar(params) {
  return listado("divisas/listar", params);
}

export function cargar(id) {
  return api.get("divisas/cargar&id=" + id).then((response) => {
    const data = response.data;
    const paises = data.paises;
    const divisa = data.divisa;

    return { divisa, paises };
  });
}

export function insertar({ divisa, paises }) {
  return api.post("divisas/insertar", { divisa, paises });
}

export function actualizar({ divisa, paises }) {
  return api.post("divisas/actualizar", { divisa, paises });
}

export function eliminar(id) {
  return api.post("divisas/eliminar", { id });
}

export async function tasasConversion(divisaId) {
  const response = await api.get("divisas/tasas&divisaId=" + divisaId);
  const tasas = response.data;

  tasas.forEach((tasa) => {
    tasa.fechaInicio = new Date(tasa.fechaInicio);
    tasa.fechaFin = new Date(tasa.fechaFin);
  });

  return tasas;
}

export async function guardarTasa(tasa) {
  return await api.post("divisas/guardarTasa", { tasa });
}

export async function eliminarTasa(id) {
  await api.post("divisas/eliminarTasa", { id });
}
